import axios from "axios";
import gaEvent from "@/assets/ga/events.json";
import CryptoJS from "crypto-js";
import moment from "moment";

export const generateSHA256Hash = {
  methods: {
    generateSHA256Hash(input) {
      return CryptoJS.SHA256(input).toString(CryptoJS.enc.Hex);
    }
  }
}

export const formater = {
  methods: {
    formatDate: (value, format) => {
      return moment(value).format(format);
    }
  }
}

export const GaTracking = {
  data() {
    return {
      gaEvent: gaEvent
    };
  },

  methods: {
    gaTracking(e) {
      const category = e.currentTarget.dataset.gaCategory;
      const label = e.currentTarget.dataset.gaLabel;
      const action = e.currentTarget.dataset.gaAction;

      this.$gtm.trackEvent({
        event: "ga-event",
        category: category,
        label: label,
        action: action
      });
    },
    // gaTracking({ category, label}) {
    //   this.$gtm.trackEvent({
    //     event: "ga-event",
    //     category: category,
    //     label: label
    //   });
    // },
    gaTrackingCustom({ category, label}) {
      this.$gtm.trackEvent({
        event: "ga-event",
        category: category,
        label: label
      });
    }
  }
};

export const LoadHtml = {
  data() {
    return {
      termUrl: "",
      input: ""
    };
  },
  computed: {
    compiledHTML() {
      return this.input;
    }
  },
  methods: {
    loadFile() {
      axios({
        method: "get",
        url: this.termUrl
      }).then(this.successLoad);
    },
    successLoad(result) {
      this.input = result.data;
    }
  }
};


